import { ClientMsgKind } from '@infiltre/shared';
import { selectEliminatedThisRound, selectRoom } from '@/entities/room';
import { useGameStore, useSessionStore } from '@/shared/hooks/use-shallow-store';
import { ClochardGuess } from '../ui/ClochardGuess';

/**
 * Standalone Clochard guess orchestrator. The eliminated player gets one shot
 * to guess the Flics' word. Submitting dispatches the engine message and
 * flips the handoff into the round-end view.
 */
export const ClochardGuessOrchestrator = () => {
  const room = useGameStore(selectRoom);
  const driver = useSessionStore((s) => s.driver);
  const clochard = useGameStore(selectEliminatedThisRound);
  const showRoundEnd = useGameStore((s) => s.showRoundEnd);

  if (!room || !driver || !clochard) return null;

  return (
    <ClochardGuess
      playerName={clochard.name}
      onGuess={(guess) => {
        driver.send({ kind: ClientMsgKind.ClochardGuess, actorPlayerId: clochard.id, guess });
        showRoundEnd();
      }}
    />
  );
};
